import {
  ActivityListAssociation,
  ActivityOption,
  AddListItemInput,
  LifeList,
  ListInput,
  ListItem,
  ListWithCount,
  TaskDefinitionOption,
  TaskListAssociation
} from '../models/list.model';

export abstract class ListsRepository {
  abstract getLists(): Promise<ListWithCount[]>;
  abstract getList(id: number): Promise<ListWithCount>;
  abstract createList(input: ListInput): Promise<LifeList>;
  abstract updateList(id: number, input: ListInput): Promise<LifeList>;
  abstract setListArchived(id: number, archived: boolean): Promise<void>;
  abstract deleteList(id: number): Promise<void>;

  abstract getItems(listId: number): Promise<ListItem[]>;
  abstract addItem(listId: number, input: AddListItemInput): Promise<ListItem>;
  abstract renameItem(itemId: number, title: string): Promise<void>;
  abstract setItemCompleted(itemId: number, completed: boolean): Promise<void>;
  abstract archiveItem(itemId: number): Promise<void>;
  abstract moveItem(itemId: number, direction: -1 | 1): Promise<void>;
  abstract purgeCompletedItems(listId: number): Promise<number>;

  abstract getTaskDefinitions(listId: number): Promise<TaskDefinitionOption[]>;
  abstract getTaskListAssociations(): Promise<TaskListAssociation[]>;
  abstract setTaskLinked(listId: number, taskDefinitionId: number, linked: boolean): Promise<void>;

  abstract getActivities(listId: number): Promise<ActivityOption[]>;
  abstract getActivityListAssociations(): Promise<ActivityListAssociation[]>;
  abstract setActivityLinked(listId: number, activityId: number, linked: boolean): Promise<void>;
}
